"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DisplayName;
(function (DisplayName) {
    DisplayName["Accordion"] = "PrezzeeAccordion";
    DisplayName["AccordionItem"] = "PrezzeeAccordionItem";
    DisplayName["AccordionItemButton"] = "PrezzeeAccordionItemButton";
    DisplayName["AccordionItemHeading"] = "PrezzeeAccordionItemHeading";
    DisplayName["AccordionItemPanel"] = "PrezzeeAccordionItemPanel";
})(DisplayName || (DisplayName = {}));
exports.default = DisplayName;
//# sourceMappingURL=DisplayName.js.map